/* unplugin-vue-components disabled */import { render } from "./MusicList.vue?vue&type=template&id=71ea7c58&scoped=true"
import script from "./MusicList.vue?vue&type=script&lang=js"
export * from "./MusicList.vue?vue&type=script&lang=js"

import "./MusicList.vue?vue&type=style&index=0&id=71ea7c58&lang=less&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71ea7c58"]])

export default __exports__